<div class="grid p-fluid">
  <form [formGroup]="requestForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="p-fluid p-formgrid grid">
      <div class="p-field col-12 md:col-6">
        @if (requestList.length !== 0) {
          <div class="col-12">
            @if (readOnly===true) {
              <h6>
                {{'Assoc_1' | translate}} : {{request._label}}
              </h6>
            }
            @if (readOnly===false) {
              <p-listbox [readonly]="readOnly" formControlName="requestList" [options]="requestList"  [metaKeySelection]="false" [checkbox]="true"
               [filter]="true" optionLabel="label" [multiple]="true" optionValue="id"  [listStyle]="{'max-height':'400px'}" [style]="{'width':'100%'}">
                <ng-template let-request pTemplate="item">
                  <div>{{request.label}}</div>
                </ng-template>
              </p-listbox>
            }
          </div>
        }
      </div>
      <div
        class="p-field col-12"
          [ngClass]="{
          'md:col-12': readOnly===true,
          'md:col-6': readOnly===false
          }"
        >
        @if (basketList.length !== 0) {
          <div class="col-12">
            <bskselect
              #bskselect
              [basketList]="basketList"
            >
            </bskselect>            
          </div>
        }
      </div>
    </div>
  </form>
</div>

<div class="foo-ter col-12 lg:col-12 md:col-12 align-right">
  @if (requestForm.controls['id'].value) {
    <button
      (click)="deleteItem()"
      class="p-button-danger p-button p-component p-button-text-only blockBottom margin"
      >
      {{'Delete' | translate}}
    </button>
  }
  <button
    (click)="cancel()"
    type="button"
    class="p-button-primary p-button-outlined p-button p-component p-button-text-only btn-square margin"
    >
    {{'Cancel' | translate}}
  </button>
  <button
    (click)="validate()"
    type="button"
    class="p-button p-component p-button-text-only btn-square margin"
    >
    {{'Valid' | translate}}
  </button>
</div>

